(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2002],{

/***/ 66838:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promo",
      function () {
        return __webpack_require__(75637);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var _containers_ErrorPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75720);
/* harmony import */ var _containers_Promo_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86845);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PromoPage = function(param) {
    var layoutProps = param.layoutProps;
    var notFound = layoutProps.notFound, page = layoutProps.page;
    if (notFound) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_ErrorPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            layout: "404"
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: page && page.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: page.title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Promo_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({}, layoutProps))
        ]
    }));
};
PromoPage.pageLayout = "promo";
PromoPage.layoutProps = {
    hasLiteHeader: true,
    displaySearch: false,
    displayBackLink: true,
    skipMiniCartFetch: false
};
/* harmony default export */ __webpack_exports__["default"] = (PromoPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1216,6845,9774,2888,179], function() { return __webpack_exec__(66838); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);